import { render, staticRenderFns } from "./CenteredLoader.vue?vue&type=template&id=1d223562"
import script from "./CenteredLoader.vue?vue&type=script&lang=js"
export * from "./CenteredLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports